var map = {
	"./en-US.json": [
		"./js/translations/en-US.json",
		"js_translations_en-US_json"
	],
	"./fr-FR.json": [
		"./js/translations/fr-FR.json",
		"js_translations_fr-FR_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./js/translations lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;